"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinderMode = void 0;
var FinderMode;
(function (FinderMode) {
    FinderMode["None"] = "None";
    FinderMode["Find"] = "Find";
    FinderMode["FindAndReplace"] = "FindAndReplace";
})(FinderMode = exports.FinderMode || (exports.FinderMode = {}));
